import UserData from '../js/userData'

type CompPermissionType = {
    id: string
    name: string
    p_id: string
    level_type: number
    menu_type: number
    url: string
    route_url: string
    order_num: number
    children: CompPermissionType[] | null
}

export default function getPermission(): string[] {
    let routerURL: string = window.location.pathname.slice(1)

    let permission: CompPermissionType[] = UserData.right_menu_list.filter((el: CompPermissionType) => {
        return el.route_url === routerURL
    })

    return permission.map(el => el.name)
}